import posts from './blogPosts.json';

// Every blog post lives in blogPosts.json, so the blog pages (BlogScreen, BlogPostScreen) and the
// build script that writes each post's crawlable HTML (scripts/generate-static-seo-pages.js) read
// the same text. A new post also needs an entry in scripts/seo-routes.js, public/sitemap.xml and a
// rewrite in vercel.json; scripts/validate-static-seo.js checks all of them.

export interface BlogPost {
    id: string;
    title: string;
    excerpt: string;
    content: string;
    category: string;
    author: string;
    date: string;
    readTime: string;
    image: string;
    tags: string[];
    featured: boolean;
}

export const BLOG_CATEGORIES = ['All', 'How It Works', 'Dating Advice', 'Safety', 'Mental Health', 'Trends', 'Relationships'];

export const blogPosts: BlogPost[] = posts;
